<template>
  <div class="container tenant-profile">
    <TenantProfileMenu />

    <form ref="tenantForm">

      <div v-if="isCompanyProfileIncomplete($store.state.user, $store.state.tenant)">
        <v-dialog :lazy="true" :width="480" v-model="tutorialDialog">
          <v-card flat class="company-profile-tutorial">

            <template v-if="tutorialDialog === 1">
              <h2>Welcome to your Membership! Complete your Company Profile</h2>
              <p>
                Welcome Admin of {{ tenantData.name || tenantData.subdomain }} PFX Brokerage Account.
                Start by completing your company profile and fill in the missing details.
              </p>
            </template>

            <template v-if="tutorialDialog === 2">
              <h2>Invite Your Agents</h2>
              <p>Next you can invite your Agents to join your PFX account to create their own auctions.</p>
            </template>

            <template v-if="tutorialDialog === 3">
              <h2>Customize your Page</h2>
              <p>Customize the look and feel of your page by choosing your brand color, upload your logo and a cover image.</p>
            </template>

            <template v-if="tutorialDialog === 4">
              <h2>Go Online!</h2>
              <p>When you’re done, you can Go Online and share your new PFX account to the public and start creating your branded auctions.</p>
            </template>

            <div class="clearfix">
              <div class="col13 align-left">
                <button v-if="tutorialDialog > 1" class="btn-invisible" @click="tutorialDialog--">Previous</button>
                <span v-else>&nbsp;</span>
              </div>
              <div class="col13 bullets">
                <v-icon size="x-small" :color="tutorialDialog === 1 ? 'darken-2' : '' + ' grey lighten-2'">lens</v-icon>
                <v-icon size="x-small" :color="tutorialDialog === 2 ? 'darken-2' : '' + ' grey lighten-2'">lens</v-icon>
                <v-icon size="x-small" :color="tutorialDialog === 3 ? 'darken-2' : '' + ' grey lighten-2'">lens</v-icon>
                <v-icon size="x-small" :color="tutorialDialog === 4 ? 'darken-2' : '' + ' grey lighten-2'">lens</v-icon>
              </div>
              <div class="col13 align-right">
                <button v-if="tutorialDialog === 4" @click.prevent.stop="tutorialDialog = false">Done</button>
                <button v-else class="btn-neutral-light" @click.prevent.stop="tutorialDialog++">Next</button>
              </div>
            </div>

          </v-card>
        </v-dialog>
      </div>

      <div class="grey-box-container">

        <div class="clearfix" v-if="$store.state.tenant.status === 'DRAFT'" >
          <div class="text">
            <p>
              Note: The company status is currently still <strong>DRAFT</strong>. It means that the website is not yet publicly visible,
              until you have entered the company information and you have activated it. You probably want also to tweak the customization
              options, like adding a company logo. You may activate the company account from the
              <router-link to="/company/activate">Go Online</router-link> tab on this page.
            </p>
          </div>
        </div>
        <h2>My Company Profile</h2>
        <fieldset>
          <label for="name">Name *</label>
          <input v-model.trim="tenantData.name" id="name" type="text" required />
        </fieldset>
        <fieldset>
          <label for="name">Company Email *</label>
          <input v-model.trim="tenantData.companyEmail" id="companyEmail" type="email" required />
        </fieldset>
        <fieldset>
          <label for="dreNumber">DRE License Number *</label>
          <input v-model.trim="tenantData.dreNumber" id="dreNumber" type="text" required />
        </fieldset>
        <fieldset>
          <label for="address">Full Address *</label>
          <input v-model="tenantData.address" placeholder="Street Address, City, State Zip Code" id="address" type="text" required />
        </fieldset>
        <fieldset>
          <label for="officePhone">Office Phone Number*</label>
          <input v-model="tenantData.officePhone" id="officePhone" type="text" title="Phone number format must be (123)123-1234567" pattern="[(][0-9]{3}[)][0-9]{3}[-][0-9]{4,7}" required />
        </fieldset>
        <!--
        <fieldset>
          <label for="fax">Fax Phone Number</label>
          <input v-model="tenantData.fax" id="fax" type="text" />
        </fieldset>
        -->
        <fieldset>
          <label for="websiteUrl">Company Website Address</label>
          <input v-model="tenantData.websiteUrl" id="websiteUrl" type="text" placeholder="e.g. http://yourcompany.com/" />
        </fieldset>
        <fieldset>
          <label for="introduction">Introduction (Who we are?) *</label>
          <textarea v-model="tenantData.introduction" id="introduction" rows="10" required></textarea>
        </fieldset>
      </div>

      <div class="grey-box-container">

        <h2>Data Import Settings: BuildOut</h2>
        <p>If you wish to import property data from the BuildOut service, please enter the apikey value here. Otherwise you can left it blank.</p>
        <fieldset>
          <label for="buildOutApiKey">BuildOut API key <small>&mdash; API key that you have received from the BuildOut administrator.</small></label>
          <input v-model.trim="tenantData.buildOutApiKey" id="buildOutApiKey" type="text" />
        </fieldset>

        <h2>Data Import Settings: RETS</h2>
        <p>If you wish to import property data from the RETS service, please fill in all the three fields below. Otherwise you can left them blank.</p>
        <fieldset>
          <label for="retsPrincipal">RETS User ID <small>&mdash; User ID that you have received from the RETS administrator, e.g. G123456789.</small></label>
          <input v-model.trim="tenantData.retsPrincipal" id="retsPrincipal" type="text" />
        </fieldset>

        <fieldset>
          <label for="retsPassword">RETS Password <small>&mdash; Password that you have received from the RETS administrator.</small></label>
          <input v-model.trim="tenantData.retsPassword" id="retsPassword" type="password" />
        </fieldset>

        <fieldset>
          <label for="retsMlsId">RETS MLS ID <small>&mdash; Identifies your company within the RETS, e.g. G7654.</small></label>
          <input v-model.trim="tenantData.retsMlsId" id="retsMlsId" type="text" />
        </fieldset>

        <fieldset class="align-right">
          <button @click.prevent="update">Update Company Profile</button>
        </fieldset>

      </div>

    </form>

  </div>
</template>

<script>
  import TenantProfileMenu from './TenantProfileMenu.vue'
  import { isCompanyProfileIncomplete } from '../utils/PfxUtils.js'

  export default {
    name: 'TenantProfile',
    components: {
      TenantProfileMenu
    },
    data() {
      return {
        tenantData: {
          subdomain: '',
          buildOutApiKey: '',
          retsPrincipal: '',
          retsPassword: '',
          retsMlsId: '',
          name: '',
          dreNumber: '',
          address: '',
          introduction: '',
          officePhone: '',
          fax: '',
          websiteUrl: '',
          companyEmail: '',
          removeLogo: false,
          removeBanner: false
        },
        tutorialDialog: false
      }
    },
    created() {
      // Fetch data which is already stored
      this.loadData()
    },
    methods: {
      isCompanyProfileIncomplete,

      loadData() {
        this.$store.commit('setLoadingSpinner', true)
        this.$PfxBackendApi.getTenantData()
          .then(res => {
            console.log('getTenantData res', res)
            this.tenantData = res.data
          })
          .catch(err => {
            console.error('getTenantData err', err)
            if (err.status === 404) {
              this.tenantData = {
                subdomain: this.$store.state.tenant.subdomain
              }
            }
          })
          .then(() => {
            this.$store.commit('setLoadingSpinner', false)
          })

        if (isCompanyProfileIncomplete(this.$store.state.user, this.$store.state.tenant)) {
          this.tutorialDialog = 1
        }
      },

      update() {
        if (!this.$refs.tenantForm.checkValidity()) {
          this.$refs.tenantForm.reportValidity()
          return
        }
        this.$store.commit('setLoadingSpinner', true)

        const submit = this.tenantData
        submit.removeLogo = false
        submit.removeBanner = false
        delete submit.logo
        delete submit.logoUrl
        delete submit.banner
        delete submit.bannerUrl

        this.$PfxBackendApi
          .updateTenant(submit)
          .then((res) => {
            console.log('updateTenant res', res)
            this.refetchTenantData()
          })
          .catch(err => {
            console.error('updateTenant err', err)
            this.$store.commit('openDialog', {
              title: 'Notification',
              text: 'Failed: ' + err.data.message,
              buttons: [{ title: 'Close this' }]
            })
          })
          .then(() => {
            this.$store.commit('setLoadingSpinner', false)
          })
      },

      refetchTenantData() {
        const subdomain = this.$store.state.tenant.subdomain
        this.$PfxBackendApi.getTenantPublic(subdomain).then(res => {
          console.log('getTenantPublic', res)
          this.$store.commit('setTenant', { subdomain: subdomain, status: this.$store.state.tenant.status, data: res.data })
        }).catch(err => {
          console.error('getTenantPublic failed', err)
        })
      }

    }
  }
</script>

<style lang="scss">

  @import '../pfx.scss';

  .col13 {
    @include column(1/3);
  }

  .text {
    @include stack();
    @include tablet-landscape-breakpoint {
      @include column(2/3)
    }
  }

  .company-profile-tutorial {
    padding: 40px 80px;
    text-align: center;

    h2 {
      font-family: 'Encode Sans', sans-serif;
      font-weight: 300;
      font-size: 24px;
      line-height: 1.25em;
      margin-bottom: 14px;
      color: #000;
    }
    .bullets {
      margin-top: 6px;
      .icon {
        margin: 4px;
      }
    }
    p {
      text-align: left;
      color: #5c5c5c;
    }
    button {
      text-align: right;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TenantProfile.vue